import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useData } from '../../data/DataProvider';
import { date } from '../../shared/formatters';
import EmptyState from '../../shared/components/EmptyState';
import SafeIcon from '../../common/SafeIcon';
import { Icons } from '../../shared/icons';

// Review requests (pass 7 §7C) — delayed Google-review asks sent after
// job completion. The cron in portal-notifier sends them; this screen is
// the agency-side audit (sent / clicked / failed).
export default function ReviewRequests() {
  const { data } = useData();
  const navigate = useNavigate();

  const sorted = useMemo(() => [...data.reviewRequests]
    .sort((a, b) => new Date(b.sent_at) - new Date(a.sent_at)), [data.reviewRequests]);

  const clickedCount = sorted.filter((item) => item.clicked).length;
  const clickRate = sorted.length ? Math.round((clickedCount / sorted.length) * 100) : 0;

  return (
    <div className="standalone-page">
      <header className="simple-header">
        <div>
          <span className="eyebrow">Reputation</span>
          <h1>Review requests</h1>
          <p className="field-hint">
            {sorted.length} sent · {clickedCount} clicked ({clickRate}%) — requests go out {data.settings.reviews.delay_hours}h after a job is completed, when enabled in Notification settings.
          </p>
        </div>
      </header>

      {!sorted.length ? (
        <EmptyState title="No review requests yet" message={`Requests are sent automatically after jobs complete. Enable them in Settings → Notifications (currently ${data.settings.reviews.enabled ? 'on' : 'off'}).`} />
      ) : (
        <section className="panel no-padding invoice-list">
          {sorted.map((request) => {
            const client = data.clients.find((item) => item.id === request.client_id);
            const job = data.jobs.find((item) => item.id === request.job_id);
            return (
              <div className="invoice-row" key={request.id}>
                <div>
                  <strong>{client?.name || 'Unknown client'}</strong>
                  <span>{job?.title || request.job_title || 'Completed job'}</span>
                </div>
                <span>Sent {date(request.sent_at)}</span>
                <span>{request.channel}</span>
                <span className={`status-pill status-${request.status === 'sent' ? 'sent' : 'failed'}`}><span className="status-dot" />{request.status}</span>
                <span className={`status-pill status-${request.clicked ? 'paid' : 'draft'}`}>
                  <span className="status-dot" />{request.clicked ? 'Clicked' : 'Not clicked'}
                </span>
                <button type="button" className="link-button" onClick={() => navigate(`/admin/clients/${request.client_id}`)}>
                  <SafeIcon icon={Icons.ArrowRight} /> Client
                </button>
              </div>
            );
          })}
        </section>
      )}
    </div>
  );
}
